import { digObject } from '@domain-group/javascript-utils'

import {
  Box, DashboardModule, ListItem, Text,
} from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'
import useTrainingLesson from '@hooks/useTrainingLesson'

interface TrainingLessonPayloadMediaProps {
  trainingLessonPayload: ReturnType<typeof useTrainingLesson>,
}

const TrainingLessonMedia = (props: TrainingLessonPayloadMediaProps) => {
  const { trainingLessonPayload } = props
  const { loading, trainingLesson } = trainingLessonPayload

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_id: trainingLesson.lesson_alias_id || trainingLesson.id,
      attachable_type: 'TrainingLesson',
      attachment_type: 'training_video',
    },
    performHttpRequests: !!trainingLesson.id,
  })

  const isAliased = !!trainingLesson.lesson_alias_id

  const { filteredAttachments } = attachmentsPayload
  const trainingLessonMedia = filteredAttachments[0]
    || { attachable_id: trainingLesson.id, attachable_type: 'TrainingLesson', attachment_type: 'training_video' }

  const trainingLessonMediaUrl = digObject(trainingLessonMedia, 'links.thumb_url')
  const { file_file_name } = trainingLessonMedia

  const {
    callbacks: {
      createOrEditAttachment,
    },
  } = useAttachment(trainingLessonMedia)

  return (
    <DashboardModule loading={loading} title="Media">
      {!loading && (
        <ListItem
          boxProps={{
            alignItems: 'center',
            borderBottom: '1px solid',
            fontSize: 'small',
            justifyContent: 'space-between',
            lineHeight: 1.3,
            padding: 'large',
          }}
          onClick={() => (
            // @ts-expect-error TS2554
            createOrEditAttachment({ hideDelete: isAliased, hideReplace: isAliased, hideUpload: isAliased })
          )}
          showAngleIcon
        >
          <Box flexDirection="column">
            <Text width="fit-content">{isAliased ? 'Using Aliased Attachments' : 'Training Lesson Media'}</Text>

            <Text color="bodyFontLightColor" fontSize="xsmall" maxWidth="80%" variant="ellipsis">
              {trainingLessonMediaUrl ? file_file_name : 'Not Uploaded'}
            </Text>
          </Box>
        </ListItem>
      )}
    </DashboardModule>
  )
}

export default TrainingLessonMedia
